import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=5616caa6&"
import script from "./Template.vue?vue&type=script&lang=ts&"
export * from "./Template.vue?vue&type=script&lang=ts&"
import style0 from "./Template.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports